function breadcrumbColor() {
    let img = $('[data-product-slider] .c-slider__swiper-slide:first-child img');

    $.adaptiveBackground.run({
        selector:             '[data-breadcrumb-color]',
        parent:               '.c-breadcrumbs',
        exclude:              [  ],
        shadeVariation:   false,
        shadePercentage:  0,
        shadeColors:  {
            light:      '#000',
            dark:       '#000'
        },

        lumaClasses:  {
            light:      "c-breadcrumbs_xxl-black",
            dark:       "c-breadcrumbs_xxl-white"
        },
        transparent: null,
        success: function($img, data) {


        }
    });

}
if ($('[data-product-slider]').length && $('[data-product-slider] .c-slider__swiper-slide:first-child img').length)  {
    breadcrumbColor()
}

calc('[data-calc]');

function calc(el) {
    let $calc = $(el);
    let $lengthInp  = $calc.find('[name="calcLength"]');
    let $heightInp  = $calc.find('[name="calcHeight"]');
    let $totalInp  = $calc.find('[name="calcTotal"]');
    let $recommendInp  = $calc.find('[name="calcRecommend"]');
    const $priceEl = $('[data-product-price]');
    const $oldPriceEl = $('[data-product-old-price]');
    let currencySymbol = Array.from($priceEl.attr('data-product-price'))[0];
    const price = $priceEl.attr('data-product-price').replace(currencySymbol, '').replace(' ','').replace(',','');
    const oldPrice = $oldPriceEl.attr('data-product-old-price').replace(currencySymbol, '').replace(' ','').replace(',','');
    const $boxSizeEl = $('.s-main-product__group_price').find('[data-box-n]');
    const boxSize = $boxSizeEl.attr('data-box-n');
    const $qtyInput = $('[data-product-qty]');
    const $totalParent = $totalInp.closest('.s-main-product__calc__itm_t');
    const $recommendParent = $recommendInp.closest('.s-main-product__calc__itm_r');
    let total  = 0;
    let recommend  = 0;
    $calc.find('input').bind("keydown", function(e) {
        var ths = $(this);
        var keyKode = e.keyCode;
        if (keyKode>95 && keyKode<106 || keyKode>47 && keyKode<58 || keyKode == 8 || keyKode == 46 || keyKode ==9 || keyKode ==13) {
        } else return false;
    });
    $calc.find('input').bind("keyup", function(e) {
        result()
    });
    function result() {
        let l = $lengthInp.val().length?$lengthInp.val()*1: 0;
        let h = $heightInp.val().length? $heightInp.val()*1: 0;
        let box = $calc.attr('data-box')*1;
        total = l*h;
        if($('[data-bulk-product-popup]').length) {
            recommend = Math.ceil((l * h));
            if ($('#extra').is(':checked'))  {
                recommend = recommend + Math.ceil(recommend / 100 * 10);
            }
            recommend = Math.ceil(recommend / 5) * 5;
        } else {
            recommend = Math.ceil((l * h / box) * 1.1);
        }
        if (total && recommend) {
            $totalInp.val(total);
            $totalInp.closest('.s-main-product__calc__itm').addClass('is-active');
            if($('[data-bulk-product-popup]').length){
                if ($('#extra').is(':checked'))  {
                    total = total + Math.ceil(total / 100 * 10);
                }
                total = Math.ceil(total/5)*5;
                $recommendInp.val(total);
                $recommendInp.closest('.s-main-product__calc__itm').addClass('is-active');
                $qtyInput.val(total);
            } else {
                $recommendInp.val(recommend);
                $recommendInp.closest('.s-main-product__calc__itm').addClass('is-active');
                $qtyInput.val(recommend);
            }
            $priceEl.html('$' + (Number(price) * recommend).toFixed(2) );
            if (Number(oldPrice) > 0) {
                $oldPriceEl.html('$' + (Number(oldPrice) * recommend).toFixed(2) );
            }
            $boxSizeEl.html(Number(boxSize) * recommend);
            if (recommend > 1) {
                $('[data-minus-btn]').prop( "disabled", false);
            }
            if (recommend > 25 && $('[data-bulk-order-popup]').length){
                $('[data-bulk-order-popup]').addClass('is-open');
            }

            setTimeout(function () {
                if (total < 500 && $('[data-bulk-product-popup]').length) {
                    $('[data-bulk-product-popup]').addClass('is-open');
                }
            }, 1000)

            if (window.innerWidth > 750) {
                let inpTotalWidth = ($totalInp.val().length + 2) * 20;
                let inpRecommendWidth = ($recommendInp.val().length + 1) * 23;
                let minTotalWidth = 136;
                let padding = 26;
                if (window.innerWidth >= 1200 && window.innerWidth < 1600) {
                    minTotalWidth = 120;
                    padding = 10;
                    inpTotalWidth = ($totalInp.val().length + 2) * 18;
                    inpRecommendWidth = ($recommendInp.val().length + 1) * 20;
                }

                if (inpTotalWidth > (minTotalWidth - padding)) {
                    $totalInp.css('width', (inpTotalWidth + 'px'));
                    $totalParent.css('width', inpTotalWidth + padding + 'px');
                    $totalParent.css('min-width', inpTotalWidth + padding + 'px');
                } else {
                    $totalInp.css('width', '110px');
                    $totalParent.css('width', minTotalWidth+'px');
                    $totalParent.css('min-width', minTotalWidth+'px');
                }
                if (inpRecommendWidth > 110) {
                    $recommendInp.css('width', (inpRecommendWidth + 20 + 'px'));
                    $recommendParent.css('width', inpRecommendWidth + 20 + 'px');
                    $recommendParent.css('min-width', inpRecommendWidth + 20 + 'px');
                } else {
                    $recommendInp.css('width', '110px');
                    $recommendParent.css('width', '110px');
                    $recommendParent.css('min-width', '110px');
                }
            }
        } else {
            $totalInp.val('');
            $totalInp.closest('.s-main-product__calc__itm').removeClass('is-active');
            $recommendInp.val('');
            $recommendInp.closest('.s-main-product__calc__itm').removeClass('is-active');
            $qtyInput.val($qtyInput.attr('min'));
            $priceEl.html(currencySymbol + (Number(price) * Number($qtyInput.val())).toFixed(2));
            if (Number(oldPrice)) {
                $oldPriceEl.html(currencySymbol + (Number(oldPrice) * Number($qtyInput.val())).toFixed(2) );
            }
            $boxSizeEl.html(boxSize);
        }
    }
}